import type { SecondaryDimensionValues } from '@revelio/core';
import type { CompositionV3BreakdownOptions } from '@revelio/data-access';

import {
  type PlotFilter,
  PlotFilterType,
} from '../../../components/PageConfigProvider/types/item';

type CompositionTopNBreakdownOptions = Pick<
  CompositionV3BreakdownOptions,
  | 'education_top_n'
  | 'ethnicity_top_n'
  | 'gender_top_n'
  | 'geography_top_n'
  | 'rics_top_n'
  | 'role_top_n'
  | 'skill_top_n'
  | 'seniority_top_n'
  | 'activities_top_n'
>;

type TopNSecondaryDimension = Extract<
  SecondaryDimensionValues,
  | 'education'
  | 'ethnicity'
  | 'gender'
  | 'geography'
  | 'rics'
  | 'role'
  | 'skills'
  | 'seniority'
  | 'activities'
>;

export const isTopNSecondaryDimension = (
  secondaryDimension?: SecondaryDimensionValues
): secondaryDimension is TopNSecondaryDimension => {
  return (
    secondaryDimension !== undefined &&
    [
      'education',
      'ethnicity',
      'gender',
      'geography',
      'rics',
      'role',
      'skills',
      'seniority',
      'activities',
    ].includes(secondaryDimension)
  );
};

export const getCompositionV3TopNBreakdown = ({
  plotFilters,
  secondaryDimension,
}: {
  plotFilters: PlotFilter[];
  secondaryDimension: TopNSecondaryDimension;
}): CompositionTopNBreakdownOptions => {
  const topNFilter = plotFilters.find(
    (filter) => filter.type === PlotFilterType.TOP_N
  );
  if (!topNFilter) return {};

  const topNValue = topNFilter.value;

  switch (secondaryDimension) {
    case 'education':
      return { education_top_n: topNValue };
    case 'ethnicity':
      return { ethnicity_top_n: topNValue };
    case 'gender':
      return { gender_top_n: topNValue };
    case 'geography':
      return { geography_top_n: topNValue };
    case 'rics':
      return { rics_top_n: topNValue };
    case 'role':
      return { role_top_n: topNValue };
    case 'skills':
      return { skill_top_n: topNValue };
    case 'seniority':
      return { seniority_top_n: topNValue };
    case 'activities':
      return { activities_top_n: topNValue };
  }
};
